import { createSlice} from "@reduxjs/toolkit";

export type updateAndDeleteAuthSliceType={
    isAuthenticated:boolean
}


const initialState:updateAndDeleteAuthSliceType={
    isAuthenticated:false
}

export const updateAndDeleteAuthSlice=createSlice({
    name:"updateAndDeleteAuthSlice",
    initialState,
    reducers:{
        changeAdAuthenticate:(state)=>{
            state.isAuthenticated=true;
        },
        expireSession:(state)=>{
            state.isAuthenticated=false;
        }

    }
})

export const {changeAdAuthenticate,expireSession}=updateAndDeleteAuthSlice.actions
export default updateAndDeleteAuthSlice.reducer;